import React from "react"

import { Box, Flex, Text, Link, Grid, useDisclosure } from "@chakra-ui/react"

import TemplateItem from "./template-item"
import ExampleDrawer from "./example-drawer"

import { SOCIAL_MEDIA_CONTENTS } from "./social-media-contents"

import { ALL_STAR_MAIL_LINK } from "../../../constants/constants"

import sectionData from "../../../../static/data/all_stars_page.json"

const styles = {
  root: {
    width: "100%",
    px: { base: "16px", md: "24px", lg: "24px" },
    bg: "#F4F7FF",
    justifyContent: "center",
  },
  content: {
    my: { base: "24px", md: "24px", lg: "60px" },
    maxWidth: "1080px",
    fontFamily: "Inter var, sans-serif",
  },
  text: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#2D3748",
    fontFamily: "Inter var, sans-serif",
  },
  link: {
    fontSize: "16px",
    color: "#3399FF",
    fontWeight: 400,
    lineHeight: "24px",
    fontFamily: "Inter var, sans-serif",
  },
}

const SectionBody = ({ data: graphQLData, year, location }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [selectedPlatform, setSelectedPlatform] = React.useState()
  const [selectedEntity, setSelectedEntity] = React.useState()
  const [selectedContent, setSelectedContent] = React.useState()

  const searchParams = new URLSearchParams(location.search)
  const selectedYear = searchParams.get("year") || "2025"

  const handleExampleLinkClick = (platform, entity, content) => {
    setSelectedPlatform(platform)
    setSelectedEntity(entity)
    setSelectedContent(content)
    onOpen()
  }

  const badges = graphQLData?.allBadges?.edges || []

  const badgeImageName = sectionData[year]?.sectionHero?.image

  const badgeItem = badges.find(item => item.node.name === badgeImageName)
  const forTitle = year === "2024" ? "Surgeons" : "Physicians"

  return (
    <Flex sx={styles.root}>
      <Box sx={styles.content}>
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(1, 1fr)",
            lg: "repeat(2, 1fr)",
          }}
          columnGap="48px"
          rowGap={{ base: "20px", md: "20px", lg: "40px" }}
        >
          <TemplateItem
            title="LinkedIn Template for Hospitals"
            imagePath={badgeItem}
            onExampleClick={() => {
              handleExampleLinkClick(
                "LinkedIn",
                "Hospitals",
                "hospitalMessageForLinkedIn"
              )
            }}
          >
            {SOCIAL_MEDIA_CONTENTS.hospitalMessageForLinkedIn(
              "[specialty]",
              year
            )}
          </TemplateItem>
          <TemplateItem
            title={`LinkedIn Template for ${forTitle}`}
            imagePath={badgeItem}
            onExampleClick={() => {
              handleExampleLinkClick(
                "LinkedIn",
                "Surgeons",
                "surgeonMessageForLinkedIn"
              )
            }}
          >
            {SOCIAL_MEDIA_CONTENTS.surgeonMessageForLinkedIn(
              "[specialty]",
              year
            )}
          </TemplateItem>

          <TemplateItem
            title="Twitter/X Template for Hospitals"
            imagePath={badgeItem}
            onExampleClick={() => {
              handleExampleLinkClick(
                "Twitter/X",
                "Hospitals",
                "hospitalMessageForTwitter"
              )
            }}
          >
            {year === "2024"
              ? SOCIAL_MEDIA_CONTENTS.hospitalMessageForTwitter(
                  "[specialty]",
                  year
                )
              : SOCIAL_MEDIA_CONTENTS.hospitalMessageForX("[specialty]", year)}
          </TemplateItem>
          <TemplateItem
            title={`Twitter/X Template for ${forTitle}`}
            imagePath={badgeItem}
            onExampleClick={() => {
              handleExampleLinkClick(
                "Twitter/X",
                "Surgeons",
                "surgeonMessageForTwitter"
              )
            }}
          >
            {year === "2024"
              ? SOCIAL_MEDIA_CONTENTS.surgeonMessageForTwitter(
                  "[specialty]",
                  year
                )
              : SOCIAL_MEDIA_CONTENTS.surgeonMessageForX("[specialty]", year)}
          </TemplateItem>

          <TemplateItem
            title="Facebook Template for Hospitals"
            imagePath={badgeItem}
            onExampleClick={() => {
              handleExampleLinkClick(
                "Facebook",
                "Hospitals",
                "hospitalMessageForFacebook"
              )
            }}
          >
            {SOCIAL_MEDIA_CONTENTS.hospitalMessageForFacebook(
              "[specialty]",
              year
            )}
          </TemplateItem>
          <TemplateItem
            title={`Facebook Template for ${forTitle}`}
            imagePath={badgeItem}
            onExampleClick={() => {
              handleExampleLinkClick(
                "Facebook",
                "Surgeons",
                "surgeonMessageForFacebook"
              )
            }}
          >
            {SOCIAL_MEDIA_CONTENTS.surgeonMessageForFacebook(
              "[specialty]",
              year
            )}
          </TemplateItem>
        </Grid>

        <Text sx={styles.text} mt="40px" maxW="590px">
          If you have any questions or difficulty with the social media
          template, please contact us at{" "}
          <Link sx={styles.link} href={ALL_STAR_MAIL_LINK}>
            Research.All-Stars@avantgardehealth.com
          </Link>
          .
        </Text>

        <ExampleDrawer
          isOpen={isOpen}
          onClose={onClose}
          selectedPlatform={selectedPlatform}
          selectedEntity={selectedEntity}
          selectedContent={selectedContent}
          selectedYear={selectedYear}
        />
      </Box>
    </Flex>
  )
}

export default SectionBody
